/*
 * WorkAndBuhin.vue の部品同一判定、検索、比較用キー生成を切り出した処理。
 */
export interface BuhinSelectedState {
  isSelected: boolean;
}

export interface JunseiBuhinDisplayState {
  isJunseiBuhin: boolean;
}

export interface BuhinIndexState {
  selectedBuhinIndex: number;
  manualBuhinIndex: number;
  junseiBuhinIndex: number;
}

/*
 * isJunseiBuhinCode を WorkAndBuhin.vue から分離し、
 * 部品同一判定 を親側置換や単体テストで固定するため。
 */
export function isJunseiBuhinCode(buhinCd: any): boolean {
  if (buhinCd) {
    const buhinCdString = String(buhinCd);
    return buhinCdString.length > 2 && buhinCdString.substring(0, 2) === "JB";
  }
  return false;
}

/*
 * buildJunseiBuhinDisplayState を WorkAndBuhin.vue から分離し、
 * 純正部品表示の判定結果を親側置換や単体テストで固定するため。
 */
export function buildJunseiBuhinDisplayState(buhinCd: any): JunseiBuhinDisplayState {
  return {
    isJunseiBuhin: isJunseiBuhinCode(buhinCd)
  };
}

/*
 * findSelectedBuhinIndex を WorkAndBuhin.vue から分離し、
 * 部品同一判定 を親側置換や単体テストで固定するため。
 */
export function findSelectedBuhinIndex(selectedBuhinList: any[], item: any): number {
  return selectedBuhinList.findIndex(
    (buhin: any) =>
      (buhin.buhinCd == item.buhinCd ||
        (buhin.buhinOsusumeId && buhin.buhinOsusumeId == item.buhinOsusumeId)) &&
      buhin.buhinNm == item.buhinNm
  );
}

/*
 * buildBuhinSelectedState を WorkAndBuhin.vue から分離し、
 * 部品選択表示の判定結果を親側置換や単体テストで固定するため。
 */
export function buildBuhinSelectedState(
  selectedBuhinList: any[],
  item: any
): BuhinSelectedState {
  const selectedIndex = findSelectedBuhinIndex(selectedBuhinList, item);
  return {
    isSelected: item.isExtreme == 1
      ? selectedIndex > -1 && item.quantity > 0
      : selectedIndex > -1
  };
}

/*
 * findManualBuhinIndex を WorkAndBuhin.vue から分離し、
 * 部品同一判定 を親側置換や単体テストで固定するため。
 */
export function findManualBuhinIndex(selectedBuhinList: any[], item: any): number {
  return selectedBuhinList.findIndex(
    (buhin: any) => !isJunseiBuhinCode(buhin.buhinCd) && buhin.buhinNm == item.buhinNm
  );
}

/*
 * findJunseiBuhinIndex を WorkAndBuhin.vue から分離し、
 * 部品同一判定 を親側置換や単体テストで固定するため。
 */
export function findJunseiBuhinIndex(selectedBuhinList: any[], item: any): number {
  return selectedBuhinList.findIndex(
    (buhin: any) => buhin.buhinCd == item.buhinCd && buhin.buhinNm == item.buhinNm
  );
}

/*
 * buildBuhinIndexState を WorkAndBuhin.vue から分離し、
 * 部品 index の検索結果を親側置換や単体テストで固定するため。
 */
export function buildBuhinIndexState(
  selectedBuhinList: any[],
  item: any
): BuhinIndexState {
  return {
    selectedBuhinIndex: findSelectedBuhinIndex(selectedBuhinList, item),
    manualBuhinIndex: findManualBuhinIndex(selectedBuhinList, item),
    junseiBuhinIndex: findJunseiBuhinIndex(selectedBuhinList, item)
  };
}

/*
 * getBuhinUniqueString を WorkAndBuhin.vue から分離し、
 * 部品同一判定 を親側置換や単体テストで固定するため。
 */
export function getBuhinUniqueString(buhin: any): string {
  if (buhin.buhinOsusumeId) {
    return "osusumeId:" + buhin.buhinOsusumeId;
  }
  if (buhin.buhinCd) {
    return "cd:" + buhin.buhinCd + buhin.buhinNm;
  }
  if (buhin.id) {
    return "id:" + buhin.id;
  }
  return "nm:" + buhin.buhinNm;
}
